import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";

export const getWorkflowGeneralTranslationValidationErrors = (isMultiLanguageEnabled: boolean, availableLanguages: Array<LocaleTypes>) => {
    let count = 0;
    const translationResources = resources.pages.workflowDetails.tabs.general.subTabs.translation;

    let availableLanguagesError = null;

    if (isMultiLanguageEnabled && availableLanguages.length === 0) {
        count++;
        availableLanguagesError = (
            <ErrorAlert>
                <span>{translationResources.inputs.languages.required}</span>
            </ErrorAlert>
        );
    }


    return {
        availableLanguagesError,
        count,
        tabTitle: <TabTitleWithErrorCount tabName={translationResources.tabName} errorCount={count} />
    }
}